import React from "react";
import { useDispatch } from "react-redux";
import { changeUniversalModal } from "../../../redux/actions/universal";
import { SolidButton } from "../../library/button";

import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();

  const clickNewSpace = () => {
    dispatch(changeUniversalModal({ newSpaceModal: true }));
  };

  return (
    <div className="new-space-container">
      <SolidButton
        size="md"
        style={{ marginTop: "5px" }}
        color="green"
        icon={<i class="fad fa-plus"></i>}
        title="Nytt foretak"
        onClick={() => clickNewSpace()}
      />
    </div>
  );
};

export default Index;
